const BUDGET_OBJECTIVE_UNITS = {
  UNITS: 'UNITS',
  PERCENTAGE: 'PERCENTAGE',
  MONETARY: 'MONETARY',
};

export const BUDGET_OBJECTIVE_UNIT_OPTIONS = {
  [BUDGET_OBJECTIVE_UNITS.UNITS]: 'units',
  [BUDGET_OBJECTIVE_UNITS.MONETARY]: '$',
  [BUDGET_OBJECTIVE_UNITS.PERCENTAGE]: '%',
};
